// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var AutoAdvance$ReactHooksTemplate = require("./autoAdvance.res.js");
var CampaignModes$ReactHooksTemplate = require("./campaignModes.res.js");
var GenerateTicket$ReactHooksTemplate = require("./generateTicket.res.js");
var ImportEnrichment$ReactHooksTemplate = require("./importEnrichment.res.js");
var PaginationPolicies$ReactHooksTemplate = require("./paginationPolicies.res.js");
var SavePartialResponse$ReactHooksTemplate = require("./savePartialResponse.res.js");
var SurveyResponseWindow$ReactHooksTemplate = require("./surveyResponseWindow.res.js");
var TicketAutoAssignment$ReactHooksTemplate = require("./ticketAutoAssignment.res.js");

function id(t) {
  return t.id;
}

function enforce(t) {
  return t.enforce;
}

function enforced(t) {
  return t.enforced;
}

function setEnforce(enforce, t) {
  return {
          id: t.id,
          individualSetting: t.individualSetting,
          enforce: enforce,
          enforced: t.enforced,
          enforcedFrom: t.enforcedFrom
        };
}

function individualSetting(t) {
  return t.individualSetting;
}

function setIndividualSetting(individualSetting, t) {
  return {
          id: t.id,
          individualSetting: individualSetting,
          enforce: t.enforce,
          enforced: t.enforced,
          enforcedFrom: t.enforcedFrom
        };
}

function decodeIndividualSetting(json) {
  var individualSettingName = Json_decode.field("name", Json_decode.string, json);
  switch (individualSettingName) {
    case "auto_advance" :
        return {
                TAG: "AutoAdvance",
                _0: AutoAdvance$ReactHooksTemplate.decode(json)
              };
    case "campaign_mode" :
        return {
                TAG: "CampaignModes",
                _0: CampaignModes$ReactHooksTemplate.decode(json)
              };
    case "generate_ticket" :
        return {
                TAG: "GenerateTicket",
                _0: GenerateTicket$ReactHooksTemplate.decode(json)
              };
    case "import_enrichment" :
        return {
                TAG: "ImportEnrichment",
                _0: ImportEnrichment$ReactHooksTemplate.decode(json)
              };
    case "pagination_policy" :
        return {
                TAG: "PaginationPolicies",
                _0: PaginationPolicies$ReactHooksTemplate.decode(json)
              };
    case "save_partial_response" :
        return {
                TAG: "SavePartialResponse",
                _0: SavePartialResponse$ReactHooksTemplate.decode(json)
              };
    case "survey_response_window" :
        return {
                TAG: "SurveyResponseWindow",
                _0: SurveyResponseWindow$ReactHooksTemplate.decode(json)
              };
    case "ticket_auto_assignment" :
        return {
                TAG: "TicketAutoAssignment",
                _0: TicketAutoAssignment$ReactHooksTemplate.decode(json)
              };
    default:
      return Js_exn.raiseError("Unknown individual setting");
  }
}

function decode(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          individualSetting: decodeIndividualSetting(json),
          enforce: Json_decode.field("enforce_to_lower", Json_decode.bool, json),
          enforced: Json_decode.field("enforced", Json_decode.bool, json),
          enforcedFrom: undefined
        };
}

function encode(t) {
  var x = t.individualSetting;
  var tmp;
  switch (x.TAG) {
    case "SavePartialResponse" :
        tmp = SavePartialResponse$ReactHooksTemplate.encode(x._0);
        break;
    case "GenerateTicket" :
        tmp = GenerateTicket$ReactHooksTemplate.encode(x._0);
        break;
    case "CampaignModes" :
        tmp = CampaignModes$ReactHooksTemplate.encode(x._0);
        break;
    case "PaginationPolicies" :
        tmp = PaginationPolicies$ReactHooksTemplate.encode(x._0);
        break;
    case "SurveyResponseWindow" :
        tmp = SurveyResponseWindow$ReactHooksTemplate.encode(x._0);
        break;
    case "AutoAdvance" :
        tmp = AutoAdvance$ReactHooksTemplate.encode(x._0);
        break;
    case "TicketAutoAssignment" :
        tmp = TicketAutoAssignment$ReactHooksTemplate.encode(x._0);
        break;
    case "ImportEnrichment" :
        tmp = ImportEnrichment$ReactHooksTemplate.encode(x._0);
        break;
    
  }
  return Json_encode.object_({
              hd: [
                "id",
                t.id
              ],
              tl: {
                hd: [
                  "enforce_to_lower",
                  t.enforce
                ],
                tl: {
                  hd: [
                    "value",
                    tmp
                  ],
                  tl: /* [] */0
                }
              }
            });
}

exports.id = id;
exports.enforce = enforce;
exports.enforced = enforced;
exports.setEnforce = setEnforce;
exports.individualSetting = individualSetting;
exports.setIndividualSetting = setIndividualSetting;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
